(function () {
  document.documentElement.classList.remove('no-js');

  var menuToggle = document.querySelector('[data-menu-toggle]');
  if (menuToggle) {
    menuToggle.addEventListener('click', function () {
      var isOpen = document.body.classList.toggle('menu-open');
      menuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  var drawer = document.querySelector('[data-cart-drawer]');
  var openers = document.querySelectorAll('[data-cart-open]');
  var closers = document.querySelectorAll('[data-cart-close]');

  function openCart() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
  }

  function closeCart() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  }

  openers.forEach(function (button) {
    button.addEventListener('click', openCart);
  });

  closers.forEach(function (button) {
    button.addEventListener('click', closeCart);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeCart();
  });

  var revealItems = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16 });

    revealItems.forEach(function (item) {
      revealObserver.observe(item);
    });
  } else {
    revealItems.forEach(function (item) {
      item.classList.add('is-visible');
    });
  }

  var sticky = document.querySelector('[data-sticky-atc]');
  var productForm = document.querySelector('[data-product-form]');
  var stickySubmit = document.querySelector('[data-sticky-submit]');

  if (sticky && productForm && 'IntersectionObserver' in window) {
    var formObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    formObserver.observe(productForm);
  }

  if (stickySubmit && productForm) {
    stickySubmit.addEventListener('click', function () {
      var submit = productForm.querySelector('button[type="submit"]');
      if (submit) submit.click();
    });
  }
})();
